import { onMounted, onActivated } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { configureBackButton, isTelegramWebAppActive } from '@/utils/telegramWebAppClient'
import { syncTelegramBackButton } from '@/utils/telegramBackButton'
import logger from '@/utils/logger'

/**
 * Optional per-view Telegram back button override.
 * Default routing is handled globally in router.afterEach via syncTelegramBackButton.
 */
export function useBackButton(options = {}) {
  const route = useRoute()
  const router = useRouter()

  const {
    visible = true,
    onBack = null,
    autoSetup = true,
  } = options

  const setupBackButton = (show = visible, callback = null) => {
    if (!isTelegramWebAppActive()) {
      return false
    }

    try {
      if (!show) {
        return configureBackButton({ visible: false })
      }

      if (typeof callback === 'function' || typeof onBack === 'function') {
        const handler = callback || onBack
        return configureBackButton({
          visible: true,
          onClick: handler,
        })
      }

      return syncTelegramBackButton(route, router)
    } catch (error) {
      logger.warn('Failed to setup back button:', error)
      return false
    }
  }

  const show = () => setupBackButton(true)
  const hide = () => setupBackButton(false)

  const apply = () => {
    if (!autoSetup) return
    setupBackButton()
  }

  onMounted(apply)
  onActivated(apply)

  return {
    setupBackButton,
    show,
    hide,
    isAvailable: isTelegramWebAppActive,
  }
}
